const moment = require(process.env.REACT_APP_TARGET === 'server'
    ? './momentServer'
    : './momentBrowser').default;

// TODO: Write an ADR on this
// TODO: Expose `date-fns` API here, whenever we decide to start using it
// date-fns is much smaller than moment, so we plan to switch eventually
// @see https://github.com/date-fns/date-fns/
module.exports = { moment };
